"use client";
import { baseApi } from "@/api/baseApi";
import { useGetBrokerDeatils } from "@/api/brokerApi";
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

export interface AppDetails {
  id: string;
  brokerName: string;
  brokerLogo: string; // path or url
  supportEmail: string;
  isWhiteLabled: boolean;
  appName?: string;
  whiteLableOptions?: {
    brokerConnectionModal: "hidden" | "custom";
    loginSignupPage: "hidden" | "custom";
    headerBanner?: boolean;
    template_banner_message?: {
      message?: string;
      cta?: string;
    };
  };
  brokerIcon?: string;
  favicon?: string;
}

interface AppDetailsContextProps {
  details: AppDetails;
  setDetails: (values: AppDetails) => void;
}

const AppDetailsContext = createContext<AppDetailsContextProps | undefined>(
  undefined,
);

// ⭐ default values
const defaultDetails: AppDetails = {
  id: process.env.NEXT_PUBLIC_BORKER_ID || "11",
  brokerName: "Leverate",
  brokerLogo:
    "https://leverate.com/wp-content/uploads/2025/03/logo-leverate-default.svg",
  supportEmail: "support@leverate.com",
  isWhiteLabled: true,
  whiteLableOptions: {
    brokerConnectionModal: "hidden",
    loginSignupPage: "custom",
  },
};

export const AppDetailsProvider = ({ children }: { children: ReactNode }) => {
  // Initialize with default, will override from localStorage later
  const [details, setAppDetails] = useState<AppDetails>(defaultDetails);

  function updateFavicon(url: string) {
    let link = document.querySelector("link[rel='icon']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    // Avoid caching — append timestamp
    link.href = `${url}?v=${Date.now()}`;
  }
  // Read localStorage on mount
  useEffect(() => {
    if (typeof window === "undefined" || !defaultDetails?.isWhiteLabled) return;
    {
      (async () => {
        try {
          const subdomain = process.env.NEXT_PUBLIC_SUBDOMAIN;

          const res = await baseApi.get(
            `/get_leverate_brokers?subdomain=${subdomain}`,
          );

          const data = res?.data?.data; // ← real API shape based on your JSON
          if (!data) return;

          // ------- change theme colors ---------
          if (data.accent_color) {
            document.documentElement.style.setProperty(
              "--accent-primary",
              data.accent_color,
            );
            // Optional secondary shade (lighter tone)
            document.documentElement.style.setProperty(
              "--accent-secondary",
              data.accent_color,
            );
          }

          // ------- change favicon --------------
          updateFavicon(data.broker_favicon_url || "/default-icon.png");

          // ------- set application info --------
          setAppDetails({
            id: process.env.NEXT_PUBLIC_BORKER_ID || "11",
            brokerName: data.broker_name,
            brokerLogo: data.broker_image_url,
            supportEmail: data.support_email,
            appName: data.broker_app_name,
            isWhiteLabled: true,
            whiteLableOptions: {
              brokerConnectionModal: "hidden",
              loginSignupPage: "custom",
              headerBanner: data.features?.strategy_template,
              template_banner_message: data?.features?.template_banner_message,
            },
          });
        } catch (error) {}
      })();
    }
  }, []);

  // Your setter with partial merging
  const setDetails = (values: AppDetails) => {
    // setAppDetails(values);
    // localStorage.setItem("app-details", JSON.stringify(values));
  };
  return (
    <AppDetailsContext.Provider value={{ details, setDetails }}>
      {children}
    </AppDetailsContext.Provider>
  );
};

export const useAppDetails = () => {
  const ctx = useContext(AppDetailsContext);
  if (!ctx)
    throw new Error("useAppDetails must be used within AppDetailsProvider");
  return ctx;
};
